import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Package, TrendingUp, TrendingDown, Bell, ArrowRight } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { StatCard } from '../components/StatCard';
import { AlertItem } from '../components/AlertItem';
export function Dashboard() {
  const [rankingTab, setRankingTab] = useState<'expensive' | 'cheap'>('expensive');
  const chartData = [{
    month: 'Jan',
    eletronicos: 4000,
    moveis: 2400,
    utilidades: 2400
  }, {
    month: 'Fev',
    eletronicos: 3000,
    moveis: 1398,
    utilidades: 2210
  }, {
    month: 'Mar',
    eletronicos: 2000,
    moveis: 9800,
    utilidades: 2290
  }, {
    month: 'Abr',
    eletronicos: 2780,
    moveis: 3908,
    utilidades: 2000
  }, {
    month: 'Mai',
    eletronicos: 1890,
    moveis: 4800,
    utilidades: 2181
  }, {
    month: 'Jun',
    eletronicos: 2390,
    moveis: 3800,
    utilidades: 2500
  }];
  const rankingData = {
    expensive: [{
      name: 'Smart TV 85" 8K',
      price: 12999,
      diff: 15
    }, {
      name: 'MacBook Pro M2',
      price: 18499,
      diff: 12
    }, {
      name: 'Geladeira French Door',
      price: 8999,
      diff: 8
    }, {
      name: 'iPhone 14 Pro Max',
      price: 9499,
      diff: 5
    }, {
      name: 'Drone DJI Mavic 3',
      price: 14500,
      diff: 4
    }],
    cheap: [{
      name: 'Cabo USB-C',
      price: 29.9,
      diff: -25
    }, {
      name: 'Mouse Sem Fio',
      price: 45.0,
      diff: -18
    }, {
      name: 'Filtro de Linha',
      price: 35.9,
      diff: -15
    }, {
      name: 'Suporte Notebook',
      price: 89.9,
      diff: -12
    }, {
      name: 'Teclado Básico',
      price: 55.0,
      diff: -10
    }]
  };
  return <div className="space-y-6" data-id="element-120">
      {/* Stat Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-121">
        <StatCard title="Produtos Monitorados" value="247" icon={Package} accentColor="navy" trend="+12" trendDirection="up" delay={0} data-id="element-122" />
        <StatCard title="Acima da Média" value="38" icon={TrendingUp} accentColor="red" trend="+5" trendDirection="down" delay={0.1} data-id="element-123" />
        <StatCard title="Abaixo da Média" value="52" icon={TrendingDown} accentColor="green" trend="-3" trendDirection="up" delay={0.2} data-id="element-124" />
        <StatCard title="Alertas Ativos" value="12" icon={Bell} accentColor="amber" trend="2 Críticos" trendDirection="neutral" delay={0.3} data-id="element-125" />
      </div>

      {/* Main Chart */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.4
    }} className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-l-navy-900" data-id="element-126">
        <div className="flex justify-between items-center mb-6" data-id="element-127">
          <h3 className="text-lg font-bold text-navy-900" data-id="element-128">
            Tendência de Preços (Últimos 6 Meses)
          </h3>
          <button className="text-sm text-navy-600 font-medium hover:text-navy-900" data-id="element-129">
            Ver relatório completo
          </button>
        </div>
        <div className="h-[350px] w-full" data-id="element-130">
          <ResponsiveContainer width="100%" height="100%" data-id="element-131">
            <LineChart data={chartData} margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5
          }} data-id="element-132">
              <CartesianGrid strokeDasharray="3 3" vertical={false} data-id="element-133" />
              <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{
              fill: '#64748b'
            }} dy={10} data-id="element-134" />
              <YAxis axisLine={false} tickLine={false} tick={{
              fill: '#64748b'
            }} tickFormatter={value => `R$${value}`} data-id="element-135" />
              <Tooltip contentStyle={{
              backgroundColor: '#fff',
              borderRadius: '8px',
              border: '1px solid #e2e8f0',
              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
            }} data-id="element-136" />
              <Legend verticalAlign="top" height={36} data-id="element-137" />
              <Line type="monotone" dataKey="eletronicos" name="Eletrônicos" stroke="#1B2A4A" strokeWidth={3} dot={{
              r: 4
            }} activeDot={{
              r: 6
            }} data-id="element-138" />
              <Line type="monotone" dataKey="moveis" name="Móveis" stroke="#475569" strokeWidth={2} data-id="element-139" />
              <Line type="monotone" dataKey="utilidades" name="Utilidades" stroke="#94a3b8" strokeWidth={2} data-id="element-140" />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </motion.div>

      {/* Bottom Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-141">
        {/* Alerts List */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.5
      }} className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-142">
          <div className="flex justify-between items-center mb-4" data-id="element-143">
            <h3 className="text-lg font-bold text-navy-900" data-id="element-144">
              Principais Alertas do Dia
            </h3>
            <button className="text-sm text-navy-600 font-medium hover:text-navy-900 flex items-center" data-id="element-145">
              Ver todos <ArrowRight className="h-4 w-4 ml-1" data-id="element-146" />
            </button>
          </div>
          <div className="space-y-1" data-id="element-147">
            <AlertItem title="Queda Brusca: Magazine Luiza" description="iPhone 13 caiu 15% nas últimas 2h" time="10m" priority="critical" data-id="element-148" />
            <AlertItem title="Amazon sem estoque" description="Oportunidade em Smart TVs Samsung" time="45m" priority="info" data-id="element-149" />
            <AlertItem title="Preço acima do mercado" description="Seu preço está 12% acima em Monitores" time="2h" priority="warning" data-id="element-150" />
            <AlertItem title="Novo concorrente" description="Kabum entrou na categoria de Cadeiras" time="3h" priority="warning" data-id="element-151" />
          </div>
        </motion.div>

        {/* Ranking Tabs */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.5
      }} className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-152">
          <div className="flex justify-between items-center mb-6" data-id="element-153">
            <h3 className="text-lg font-bold text-navy-900" data-id="element-154">Ranking Rápido</h3>
            <div className="bg-slate-100 p-1 rounded-lg flex text-xs font-medium" data-id="element-155">
              <button onClick={() => setRankingTab('expensive')} className={`px-3 py-1.5 rounded-md transition-all ${rankingTab === 'expensive' ? 'bg-white text-navy-900 shadow-sm' : 'text-slate-500 hover:text-navy-700'}`} data-id="element-156">
                Mais Caros
              </button>
              <button onClick={() => setRankingTab('cheap')} className={`px-3 py-1.5 rounded-md transition-all ${rankingTab === 'cheap' ? 'bg-white text-navy-900 shadow-sm' : 'text-slate-500 hover:text-navy-700'}`} data-id="element-157">
                Mais Baratos
              </button>
            </div>
          </div>

          <div className="space-y-4" data-id="element-158">
            {rankingData[rankingTab].map((item, idx) => <div key={idx} className="flex items-center justify-between p-3 hover:bg-slate-50 rounded-lg transition-colors border-b border-slate-50 last:border-0" data-id="element-159">
                <div className="flex items-center" data-id="element-160">
                  <span className="w-6 text-sm font-bold text-slate-300" data-id="element-161">
                    #{idx + 1}
                  </span>
                  <span className="text-sm font-medium text-navy-900" data-id="element-162">
                    {item.name}
                  </span>
                </div>
                <div className="text-right" data-id="element-163">
                  <p className="text-sm font-bold text-navy-900" data-id="element-164">
                    R${' '}
                    {item.price.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2
                })}
                  </p>
                  <p className={`text-xs font-medium ${rankingTab === 'expensive' ? 'text-red-500' : 'text-emerald-500'}`} data-id="element-165">
                    {rankingTab === 'expensive' ? '+' : ''}
                    {item.diff}% vs média
                  </p>
                </div>
              </div>)}
          </div>
        </motion.div>
      </div>
    </div>;
}